// The slim, dismissible landscape prompt on a portrait phone, once per
// device. The rotated presentation itself is a stub: the board still fills
// the height in portrait.
import { useState } from 'react';
import { dismissLandscapePrompt, landscapePromptDismissed } from '../../systems/settings/landscapePrompt';
import { Icon } from '../components/Icon';

export function LandscapePrompt() {
  const [dismissed, setDismissed] = useState(landscapePromptDismissed);
  if (dismissed) return null;
  return (
    <div className="landscape-prompt panel" role="note">
      <span>Written in the Stars is meant for landscape. Turn your phone sideways.</span>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          dismissLandscapePrompt();
          setDismissed(true);
        }}
      >
        <Icon name="close" small />
      </button>
    </div>
  );
}
